import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';

class Item extends Component {
  render() {
    const {id, tittle, content, image, date} = this.props.new;
    const toDate = date.toDate();
    const dateNew = toDate.toLocaleDateString();
    const descripcion = content.substring(300, -1);

    return (
      <>
        <div className="col-lg-4 col-md-6 col-12 pb-5">
          <Link to={`/News/${id}`}>
            <div className="pb-4">
              <div
                className="New customizableImage"
                style={{
                  backgroundImage: `url(${image})`,
                }}
              >
                <div className="infoNew customizableImage">
                  <p className="TextinfoNew customizableImage">
                    VER NOTICIA COMPLETA <br></br>
                    <Icon name="eye" size="big" />
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div>
                <div className="tittleNew">
                  <h1>{tittle}</h1>
                </div>

                <p className="Description">{descripcion}...</p>
                <div className="dateNew">
                  <h2>Publicado:{dateNew}</h2>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </>
    );
  }
}

export default Item;
